// extracted by mini-css-extract-plugin
export default {"btn":"Contact_btn__JzanX","contactFooter":"Contact_contactFooter__pSYnC","map":"Contact_map__K11U2","textbox":"Contact_textbox__MzZqJ"};